import * as React from 'react';

import { Messages } from '../../../../gen-src/Localize';
import { SvgGroupPaperclip } from '../../../../gen-src/icons/GroupPaperclip';
import { TableDatabaseNameFragment } from '../../../../gen-src/queries/TableDatabaseNameFragment';

function tableDatabaseName(table: TableDatabaseNameFragment): string | null {
  if (table.__typename === 'DatabaseTable' && table.database) {
    return table.database.name;
  }
  return null;
}

function tableDatabaseHostName(table: TableDatabaseNameFragment): string | null {
  if (table.__typename === 'DatabaseTable' && table.database && table.database.__typename === 'DatabaseServer') {
    return table.database.hostName;
  }
  return null;
}

function tableFilePath(table: TableDatabaseNameFragment): string | null {
  if (table.__typename === 'DatabaseTable' && table.database && table.database.__typename === 'File') {
    return table.database.filePath;
  }
  return null;
}

export function tableDatabaseGroupIcon(table: TableDatabaseNameFragment): JSX.Element | null {
  if (table.__typename === 'DatabaseTable' && table.database && table.database.isGrouped) {
    // If the feature flag is disabled, isGrouped will still be falsy, so display no icon.
    return <SvgGroupPaperclip />;
  }
  return null;
}

export function tableDatabaseCellTitle(table: TableDatabaseNameFragment): string | null {
  if (table.__typename === 'DatabaseTable' && table.database && table.database.isGrouped) {
    return Messages.GroupedDatabaseTitle({ name: tableDatabaseName(table) ?? '' });
  }
  return null;
}

export function getDatabaseDisplayString(table: TableDatabaseNameFragment): string {
  const databaseName = tableDatabaseName(table);
  const databaseHostName = tableDatabaseHostName(table);
  const filePath = tableFilePath(table);

  if (filePath) {
    return filePath;
  } else if (databaseName) {
    return databaseHostName
      ? Messages.DatabaseWithHostname({ databaseName: databaseName, databaseHostName: databaseHostName })
      : databaseName;
  } else {
    return '';
  }
}
